"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = require("./state");
var mutations_1 = require("./mutations");
var getters_1 = require("./getters");
var actions_1 = require("./actions");
var Search = /** @class */ (function () {
    // create everything
    function Search(plugins) {
        // resolve namespacing, applies "foo/bar/..." stuff automatically
        this.namespaced = true;
        this.mutations = mutations_1.default;
        this.getters = getters_1.default;
        this.actions = actions_1.default;
        this.plugins = [];
        this.state = new state_1.State();
        this.plugins = plugins;
    }
    return Search;
}());
exports.Search = Search;
//# sourceMappingURL=index.js.map